import { truncate } from 'lodash';

export const truncateTargetName = targetName => truncate(targetName, { length: 30, omission: '...' });
